import { StorageType } from "../OptionResolver.types";
import { CookieStorage } from "./providers/CookieStorage";
import { LocalStorage } from "./providers/LocalStorage";
import { NoStorage } from "./providers/NoStorage";
export class StorageManager {
    constructor(storageType) {
        this.provider = this.getProvider(storageType);
    }
    /**
     * Get the storage provider base on requested storage type
     * @param storageType request type of storage
     * @returns A storage provider according to requested storage type
     */
    getProvider(storageType) {
        switch (storageType) {
            case StorageType.COOKIE:
                return new CookieStorage();
            case StorageType.LOCAL:
                return new LocalStorage();
            case StorageType.NONE:
            default:
                return new NoStorage();
        }
    }
    /**
     * Allows to set up a different storage type
     * @param storageType
     */
    setStorageType(storageType) {
        this.provider = this.getProvider(storageType);
    }
    /**
     * Retrieve the current key stored
     * @returns A string if key is found, `null` otherwise
     */
    get() {
        return this.provider.get(StorageManager.STORAGE_KEY);
    }
    /**
     * Store the provided value in current storage
     * @param value - The value to store
     */
    set(value) {
        this.provider.set(StorageManager.STORAGE_KEY, value, StorageManager.TTL);
    }
    /**
     * Remove stored value
     */
    delete() {
        this.provider.delete(StorageManager.STORAGE_KEY);
    }
}
StorageManager.STORAGE_KEY = "bs-darkmode-theme";
StorageManager.TTL = 4 * 3600000; // 4 hours in milliseconds
